// This file contains all questions from the test and their groupings by dimension

const questions = [
  {
    id: 1,
    options: [
      "Saya lebih suka mengatur waktu sendiri.",
      "Saya lebih suka mengikuti jadwal yang sudah ditentukan."
    ],
    metadata: {
      0: { dimensionTrait: "flexibility" },
      1: { dimensionTrait: "structure" }
    }
  },
  {
    id: 2,
    options: [
      "Saya sering merasa sangat terorganisir.",
      "Saya merasa agak berantakan dalam banyak hal."
    ],
    metadata: {
      0: { dimensionTrait: "structure" },
      1: { dimensionTrait: "flexibility" }
    }
  },
  {
    id: 3,
    options: [
      "Saya merasa senang berada di tengah-tengah keramaian.",
      "Saya lebih nyaman dengan kesendirian."
    ],
    metadata: {
      0: { dimensionTrait: "extrovert" },
      1: { dimensionTrait: "introvert" }
    }
  },
  {
    id: 4,
    options: [
      "Saya lebih senang berbicara tentang ide-ide baru.",
      "Saya lebih senang berbicara tentang pengalaman hidup."
    ],
    metadata: {
      0: { dimensionTrait: "conceptual" },
      1: { dimensionTrait: "practical" }
    }
  },
  {
    id: 5,
    options: [
      "Saya lebih suka menciptakan alat baru untuk pekerjaan saya.",
      "Saya lebih suka bekerja dengan alat yang sudah ada."
    ],
    metadata: {
      0: { dimensionTrait: "conceptual" },
      1: { dimensionTrait: "practical" }
    }
  },
  {
    id: 6,
    options: [
      "Saya lebih suka bekerja dengan tujuan jangka panjang.",
      "Saya lebih suka fokus pada tujuan jangka pendek."
    ],
    metadata: {
      0: { dimensionTrait: "conceptual" },
      1: { dimensionTrait: "practical" }
    }
  },
  {
    id: 7,
    options: [
      "Saya cenderung menunda-nunda pekerjaan.",
      "Saya cenderung menyelesaikan tugas tepat waktu."
    ],
    metadata: {
      0: { dimensionTrait: "flexibility" },
      1: { dimensionTrait: "structure" }
    }
  },
  {
    id: 8,
    options: [
      "Saya merasa mudah untuk mengenal orang baru.",
      "Saya cenderung lebih tertutup dan membutuhkan waktu untuk membuka diri."
    ],
    metadata: {
      0: { dimensionTrait: "extrovert" },
      1: { dimensionTrait: "introvert" }
    }
  },
  {
    id: 9,
    options: [
      "Saya suka mengambil inisiatif dalam berbagai situasi.",
      "Saya lebih suka menunggu orang lain mengambil langkah pertama."
    ],
    metadata: {
      0: { dimensionTrait: "independent" },
      1: { dimensionTrait: "collaborative" }
    }
  },
  {
    id: 10,
    options: [
      "Saya merasa lebih produktif di malam hari.",
      "Saya merasa lebih produktif di pagi hari."
    ],
    metadata: {
      0: { dimensionTrait: "flexibility" },
      1: { dimensionTrait: "structure" }
    }
  },
  {
    id: 11,
    options: [
      "Saya lebih suka jika keputusan dibuat bersama dengan orang lain.",
      "Saya lebih suka bertanggung jawab atas keputusan saya."
    ],
    metadata: {
      0: { dimensionTrait: "collaborative" },
      1: { dimensionTrait: "independent" }
    }
  },
  {
    id: 12,
    options: [
      "Saya mudah merasa cemas dalam situasi baru.",
      "Saya merasa antusias dengan hal-hal baru."
    ],
    metadata: {
      0: { dimensionTrait: "caution" },
      1: { dimensionTrait: "risk" }
    }
  },
  {
    id: 14,
    options: [
      "Saya merasa lebih baik ketika memiliki jadwal yang padat.",
      "Saya merasa lebih baik ketika memiliki waktu luang yang cukup."
    ],
    metadata: {
      0: { dimensionTrait: "structure" },
      1: { dimensionTrait: "flexibility" }
    }
  },
  {
    id: 15,
    options: [
      "Saya lebih berhati-hati dalam mengambil keputusan.",
      "Saya cenderung mengambil risiko dalam hidup."
    ],
    metadata: {
      0: { dimensionTrait: "caution" },
      1: { dimensionTrait: "risk" }
    }
  },
  {
    id: 16,
    options: [
      "Saya lebih sering menikmati saat ini dan tidak terlalu memikirkan masa depan.",
      "Saya lebih sering berpikir tentang masa depan."
    ],
    metadata: {
      0: { dimensionTrait: "practical" },
      1: { dimensionTrait: "conceptual" }
    }
  },
  {
    id: 17,
    options: [
      "Saya lebih sering merasa pesimis.",
      "Saya lebih sering merasa optimis."
    ],
    metadata: {
      0: { dimensionTrait: "caution" },
      1: { dimensionTrait: "risk" }
    }
  },
  {
    id: 18,
    options: [
      "Saya lebih suka memberikan gambaran umum saja.",
      "Saya lebih suka menjelaskan sesuatu secara detail."
    ],
    metadata: {
      0: { dimensionTrait: "conceptual" },
      1: { dimensionTrait: "practical" }
    }
  },
  {
    id: 19,
    options: [
      "Saya lebih suka hidup dengan kebebasan dan tanpa banyak aturan.",
      "Saya lebih suka hidup dengan peraturan yang jelas."
    ],
    metadata: {
      0: { dimensionTrait: "flexibility" },
      1: { dimensionTrait: "structure" }
    }
  },
  {
    id: 20,
    options: [
      "Saya lebih suka meluangkan waktu untuk melakukan sesuatu dengan hati-hati.",
      "Saya lebih suka melakukan hal-hal dengan cepat."
    ],
    metadata: {
      0: { dimensionTrait: "caution" },
      1: { dimensionTrait: "risk" }
    }
  },
  {
    id: 21,
    options: [
      "Saya lebih suka suasana yang lebih bebas dan acak.",
      "Saya lebih suka berorganisasi dengan rapi."
    ],
    metadata: {
      0: { dimensionTrait: "flexibility" },
      1: { dimensionTrait: "structure" }
    }
  },
  {
    id: 22,
    options: [
      "Saya lebih senang bekerja dengan banyak petunjuk dan arahan.",
      "Saya lebih senang bekerja dengan sedikit petunjuk."
    ],
    metadata: {
      0: { dimensionTrait: "structure" },
      1: { dimensionTrait: "flexibility" }
    }
  },
  {
    id: 23,
    options: [
      "Saya merasa nyaman dalam situasi yang sangat terorganisir.",
      "Saya merasa lebih bebas dalam situasi yang tidak terlalu terorganisir."
    ],
    metadata: {
      0: { dimensionTrait: "structure" },
      1: { dimensionTrait: "flexibility" }
    }
  },
  {
    id: 24,
    options: [
      "Saya lebih suka bekerja dengan sedikit interupsi.",
      "Saya lebih suka bekerja dengan banyak interaksi."
    ],
    metadata: {
      0: { dimensionTrait: "introvert" },
      1: { dimensionTrait: "extrovert" }
    }
  },
  {
    id: 25,
    options: [
      "Saya senang memimpin kelompok.",
      "Saya lebih suka mengikuti arahan orang lain."
    ],
    metadata: {
      0: { dimensionTrait: "independent" },
      1: { dimensionTrait: "collaborative" }
    }
  },
  {
    id: 26,
    options: [
      "Saya lebih suka berfokus pada satu hal pada suatu waktu.",
      "Saya lebih suka mengerjakan beberapa hal sekaligus."
    ],
    metadata: {
      0: { dimensionTrait: "structure" },
      1: { dimensionTrait: "flexibility" }
    }
  },
  {
    id: 27,
    options: [
      "Saya lebih suka pekerjaan yang lebih kreatif dan tidak terstruktur.",
      "Saya lebih suka melakukan pekerjaan secara sistematis."
    ],
    metadata: {
      0: { dimensionTrait: "flexibility" },
      1: { dimensionTrait: "structure" }
    }
  },
  {
    id: 28,
    options: [
      "Saya senang mendengarkan pendapat orang lain.",
      "Saya lebih suka memberikan pendapat saya terlebih dahulu."
    ],
    metadata: {
      0: { dimensionTrait: "collaborative" },
      1: { dimensionTrait: "independent" }
    }
  },
  {
    id: 29,
    options: [
      "Saya merasa lebih bahagia jika saya bisa membantu orang lain.",
      "Saya merasa lebih bahagia jika saya bisa mencapai tujuan pribadi saya."
    ],
    metadata: {
      0: { dimensionTrait: "collaborative" },
      1: { dimensionTrait: "independent" }
    }
  },
  {
    id: 30,
    options: [
      "Saya lebih suka merencanakan segala sesuatu secara detail.",
      "Saya lebih suka menjalani hidup dengan spontan."
    ],
    metadata: {
      0: { dimensionTrait: "structure" },
      1: { dimensionTrait: "flexibility" }
    }
  },
  {
    id: 31,
    options: [
      "Saya lebih suka suasana yang ramai dan sibuk.",
      "Saya lebih suka suasana yang tenang dan damai."
    ],
    metadata: {
      0: { dimensionTrait: "extrovert" },
      1: { dimensionTrait: "introvert" }
    }
  },
  {
    id: 32,
    options: [
      "Saya lebih suka pekerjaan yang lebih praktis.",
      "Saya lebih suka melakukan pekerjaan yang membutuhkan pemikiran kritis."
    ],
    metadata: {
      0: { dimensionTrait: "practical" },
      1: { dimensionTrait: "conceptual" }
    }
  },
  {
    id: 33,
    options: [
      "Saya lebih suka belajar secara mandiri.",
      "Saya lebih suka belajar dalam kelompok."
    ],
    metadata: {
      0: { dimensionTrait: "independent" },
      1: { dimensionTrait: "collaborative" }
    }
  },
  {
    id: 34,
    options: [
      "Saya lebih suka suasana yang penuh energi.",
      "Saya lebih suka suasana yang tenang dan rileks."
    ],
    metadata: {
      0: { dimensionTrait: "extrovert" },
      1: { dimensionTrait: "introvert" }
    }
  },
  {
    id: 35,
    options: [
      "Saya lebih suka bekerja dengan otak.",
      "Saya lebih suka bekerja dengan tangan."
    ],
    metadata: {
      0: { dimensionTrait: "conceptual" },
      1: { dimensionTrait: "practical" }
    }
  },
  {
    id: 36,
    options: [
      "Saya lebih suka menjalani hari dengan cara yang fleksibel.",
      "Saya lebih suka memiliki rutinitas harian yang tetap."
    ],
    metadata: {
      0: { dimensionTrait: "flexibility" },
      1: { dimensionTrait: "structure" }
    }
  },
  {
    id: 37,
    options: [
      "Saya lebih nyaman berbicara di depan banyak orang.",
      "Saya merasa gugup saat berbicara di depan orang banyak."
    ],
    metadata: {
      0: { dimensionTrait: "extrovert" },
      1: { dimensionTrait: "introvert" }
    }
  },
  {
    id: 38,
    options: [
      "Saya lebih suka merencanakan acara atau kegiatan.",
      "Saya lebih suka ikut serta dalam acara yang sudah direncanakan orang lain."
    ],
    metadata: {
      0: { dimensionTrait: "independent" },
      1: { dimensionTrait: "collaborative" }
    }
  },
  {
    id: 39,
    options: [
      "Saya lebih suka berpergian dengan teman-teman.",
      "Saya lebih suka berpergian sendiri."
    ],
    metadata: {
      0: { dimensionTrait: "extrovert" },
      1: { dimensionTrait: "introvert" }
    }
  },
  {
    id: 40,
    options: [
      "Saya lebih fokus pada kehidupan sekarang.",
      "Saya suka merencanakan masa depan."
    ],
    metadata: {
      0: { dimensionTrait: "practical" },
      1: { dimensionTrait: "conceptual" }
    }
  },
  {
    id: 41,
    options: [
      "Saya lebih suka bekerja dengan santai tanpa tekanan.",
      "Saya lebih suka bekerja di bawah tekanan."
    ],
    metadata: {
      0: { dimensionTrait: "caution" },
      1: { dimensionTrait: "risk" }
    }
  },
  {
    id: 42,
    options: [
      "Saya lebih suka berlibur ke tempat yang tenang dan damai.",
      "Saya lebih suka berlibur ke tempat yang ramai dan penuh aktivitas."
    ],
    metadata: {
      0: { dimensionTrait: "introvert" },
      1: { dimensionTrait: "extrovert" }
    }
  },
  {
    id: 43,
    options: [
      "Saya lebih suka menghabiskan waktu di luar rumah.",
      "Saya lebih suka menghabiskan waktu di rumah."
    ],
    metadata: {
      0: { dimensionTrait: "extrovert" },
      1: { dimensionTrait: "introvert" }
    }
  },
  {
    id: 44,
    options: [
      "Saya lebih suka bekerja dengan konsep dan ide.",
      "Saya lebih suka bekerja dengan alat dan mesin."
    ],
    metadata: {
      0: { dimensionTrait: "conceptual" },
      1: { dimensionTrait: "practical" }
    }
  },
  {
    id: 45,
    options: [
      "Saya lebih suka bekerja di dalam tim.",
      "Saya lebih suka bekerja sendiri."
    ],
    metadata: {
      0: { dimensionTrait: "extrovert" },
      1: { dimensionTrait: "introvert" }
    }
  },
  {
    id: 46,
    options: [
      "Saya merasa mudah beradaptasi dengan perubahan.",
      "Saya kesulitan beradaptasi dengan perubahan."
    ],
    metadata: {
      0: { dimensionTrait: "risk" },
      1: { dimensionTrait: "caution" }
    }
  },
  {
    id: 47,
    options: [
      "Saya lebih suka berinteraksi dengan orang yang memiliki pandangan yang sama dengan saya.",
      "Saya lebih suka berinteraksi dengan orang yang memiliki pandangan yang berbeda."
    ],
    metadata: {
      0: { dimensionTrait: "collaborative" },
      1: { dimensionTrait: "independent" }
    }
  },
  {
    id: 48,
    options: [
      "Saya merasa lebih nyaman dalam situasi yang terstruktur.",
      "Saya merasa lebih nyaman dalam situasi yang tidak terstruktur."
    ],
    metadata: {
      0: { dimensionTrait: "structure" },
      1: { dimensionTrait: "flexibility" }
    }
  },
  {
    id: 49,
    options: [
      "Saya lebih suka bekerja dalam lingkungan yang lebih santai dan kolaboratif.",
      "Saya lebih suka bekerja dalam lingkungan yang kompetitif."
    ],
    metadata: {
      0: { dimensionTrait: "collaborative" },
      1: { dimensionTrait: "independent" }
    }
  },
  {
    id: 50,
    options: [
      "Saya lebih nyaman di tempat yang sudah familiar.",
      "Saya suka berpetualang ke tempat baru."
    ],
    metadata: {
      0: { dimensionTrait: "caution" },
      1: { dimensionTrait: "risk" }
    }
  }
];

// Group questions by dimension for consistency checking
// Each dimension has multiple questions that test the same trait
const dimensionGroups = {
  // Structure vs. Flexibility
  'structureVsFlexibility': [1, 2, 7, 19, 21, 23, 27, 30, 36, 48],
  
  // Introversion vs. Extroversion
  'introvertVsExtrovert': [3, 8, 24, 31, 34, 37, 39, 42, 43, 45],
  
  // Practical vs. Conceptual
  'practicalVsConceptual': [4, 5, 18, 32, 35, 44],
  
  // Risk-taking vs. Caution
  'riskVsCaution': [12, 15, 17, 20, 46, 50],
  
  // Independent vs. Collaborative
  'independentVsCollaborative': [9, 11, 25, 28, 29, 33, 38, 47, 49]
};

export { questions, dimensionGroups };
